import { BehaviorSubject } from 'rxjs';
import { IDatagridSettings } from '@core-lib/models';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class DataTableConfigService {
	listColumnConfig: Array<IDatagridSettings<any>>;
	dataGridSettings$: BehaviorSubject<Array<IDatagridSettings<any>>> = new BehaviorSubject<Array<IDatagridSettings<any>>>([]);

	init(columnSetting: IDatagridSettings<any>) {
		let cols = this.dataGridSettings$.value;
		if (!cols.find(x => x.name == columnSetting.name)) {
			cols.push(columnSetting);
			this.dataGridSettings$.next(cols);
		}
	}

	public getDataGridSettingsByName(name: string): IDatagridSettings<any> {
		return this.dataGridSettings$.value?.find(x => x.name == name);
	}

	resetDataGridSettings(columnSetting: IDatagridSettings<any>) {
		let cols = this.dataGridSettings$.value;
		cols = cols.filter(x => x.name != columnSetting.name);
		cols.push(columnSetting);
		this.dataGridSettings$.next(cols);
	}
}
